@if(templateForPermitForm){
<div>
  <input
    #fileUpload
    style="display: none;"
    type="file"
    id="customFile"
    [accept]="validDocumentTypes"
    [multiple]="allowMultipleFiles"
  />

  <wm-common-button
    #uploadButton
  class="upload-button"
  [data]="{
text:buttonText.toUpperCase(),
onClick: onClick.bind(this)
}"

>
</wm-common-button>

<div *ngIf="attachmentTemplate" class="file-content">
<wm-common-text
[data]="{
  text: `Valid Document Types: ${
    validDocumentTypes || '.pdf,.jpeg,.jpg,.xls,.doc,.docx,.xlsx'
  }`
}" class="valid-type-text"
>
</wm-common-text>
<wm-common-text
[data]="{text:`${documentCount} document(s)`}"
class="document-text"
></wm-common-text>
</div>
@if(!attachmentTemplate){
  <span  style="padding-left: 10px;" *ngIf="files && files.length > 0 ">
    {{ files[0].progress }}%
  </span>
}@else{
  <div *ngIf="files && files.length > 0" class="loader-overlay">
    <div class="loader"></div>
  </div>
}
</div>
}@else{
  <!-- added by priya 22-12-2025 -->
<div>
  <input
    #fileUpload
    style="display: none;"
    type="file"
    id="customFile"
    hidden
    [accept]="validDocumentTypes"
    [multiple]="allowMultipleFiles"
  />
  <div class="mt-2">
    <button
      class="btn btn-raised btn-primary"
      type="button"
      (click)="onClick()"
    >
      {{ buttonText }}
    </button>
  </div>
  <span
    style="padding-left: 10px"
    *ngIf="files && files.length > 0"
  >
    {{ files[0].progress }} %
  </span>
</div>
}
  <!-- end by priya 22-12-2025 -->

<!-- Files being uploaded -->
<div *ngIf="allowMultipleFiles && !attachmentTemplate">
  <ul *ngIf="files.length > 0">
    <li *ngFor="let file of files">
      <!-- added by priya 22-12-2025 -->
      @if(templateForPermitForm){
      <wm-common-text
        [data]="{text:`${file.data.name} (${file.size}) - ${file.progress}`}"
      >
      </wm-common-text>
      }@else{
      {{ file.data.name }} ({{ file.size }}) - {{ file.progress }}% }
            <!-- end by priya 22-12-2025 -->

    </li>
  </ul>
</div>

<!-- successfully uploaded files -->
<ul class="list-group" *ngIf="showUploadedFilesList"    [ngClass]="{'janus-list-group':attachmentTemplate}"
>
  <li
    *ngFor="let f of uploadedFiles"
    [ngStyle]="{ cursor: allowSelect ? 'pointer' : 'default' }"
    [class.list-group-item]="!attachmentTemplate"
  [class.janus-list]="attachmentTemplate"
  >
    <div class="row" [ngClass]="{'row-janus':attachmentTemplate}">
      <div
        [class]="showRemove ? 'col-xs-10' : 'col-xs-12'"
        style="padding-top: 10px"
        [ngClass]="{'row-data':attachmentTemplate}"
      >
       <a
       href="{{ f.path }}"
       target="_blank"
       [ngClass]="{
    'link-color': templateForPermitForm && !attachmentTemplate,
    'attachment-underline': attachmentTemplate
  }"
     >
       <wm-common-text
         *ngIf="attachmentTemplate"
         [data]="{ text: f.documentName || f.name}"
         class="file-name"
       ></wm-common-text>

       <span *ngIf="!attachmentTemplate">
         {{ f.documentName || f.name}}
       </span>
     </a>
      </div>
      <div class="col-xs-3"     [ngClass]="{'janus-delete-review-content':attachmentTemplate}"
      >
        @if(!templateForPermitForm){
        <wm-modal-confirm
          [moduleId]="'delete_document' + f.id"
          commandText="Delete"
          title="Delete Document"
          [showButtonText]="true"
          (accepted)="deleteFile(f)"
          [enabled]="true"
        >
          <p>Are you sure you want to delete {{ f.name }}?</p>
          <ng-container *ngIf="deleteDocumentMessage">
            <p>{{ deleteDocumentMessage }}</p>
          </ng-container>
        </wm-modal-confirm>
      }
        <!-- added by priya 22-12-2025 -->

      @else {
       @if(!this.attachmentTemplate){
        <wm-common-button
        class="delete-button"
        [data]="{
          text: 'Delete',
          onClick: openDeleteModal.bind(this,f)
        }"
      >
      </wm-common-button>

    }@else{
        <wm-common-icon
        [data]="{ iconName: deleteIcon,
        }"
        (click)="openDeleteModal(f)"
        class="delete-icon"
      ></wm-common-icon>


    }

      }
      <div class="review-required-container" *ngIf="context.janusLayout === 'staff'">
        <wm-common-checkbox
                class="review-checkbox"

  *ngIf="(requireReview || f.reviewRequired) && !f.reviewedBy"
  [(ngModel)]="f.markAsReview"
        (ngModelChange)="markReviewed(f)"
        [data]="{
          label: 'Mark as Reviewed',
          name: 'review-' + f.id
        }"
      ></wm-common-checkbox>
  <div *ngIf="f.reviewedOn">
    <wm-common-text
    [data]="{
      text: 'Reviewed on ' + formatReviewedOn(f.reviewedOn)  + ' by ' + f.reviewedBy
    }" class="review-text">
  </wm-common-text>  </div>
      </div>

              <!-- end by priya 22-12-2025 -->

      </div>
    </div>
  </li>
  <wm-common-confirmation-modal
  #deleteModal
  [data]="deleteModalData"
  (onNoClick)="closeDeleteModal()"
  (onYesClick)="handleDeleteFile()"
></wm-common-confirmation-modal>
</ul>

<div class="row" *ngIf="validDocumentTypes">
  <div class="col-12">
    @if(!templateForPermitForm){
    <span>Valid Document Types: {{ validDocumentTypes }}</span>
    }
            <!-- added by priya 22-12-2025 -->

    @else{
    <wm-common-text *ngIf="!attachmentTemplate"
      [data]="{text:`Valid Document Types: ${ validDocumentTypes}`}" class="valid-type-text"
    >
    </wm-common-text>
    }
            <!-- end by priya 22-12-2025 -->

  </div>
</div>
